import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/modules/product-ajax-form';
import Swatches from '@archetype-themes/scripts/modules/swatches';

class ProductGridItem extends HTMLElement {
  constructor() {
    super();

    this.swatches = new Swatches(this);

    this.form = this.querySelector('.product-single__form');

    this.initAjaxProductForm();

    document.dispatchEvent(new CustomEvent('product-grid-item:loaded'));

    this.variantPrice = this.querySelector('.variant-price');
    this.variantsSelector = this.querySelector('.product-single__variants');
    if(this.variantsSelector != null && !this.variantsSelector.classList.contains('hide')) {
      this.variantsSelector.addEventListener('change', this.changeVariant.bind(this));
    }
  }
  changeVariant (e) {
    let value = e.target.value;
    let options = e.target.options;
    
    for(let i = 0; i < options.length; i++) {
      if(value == options[i].value) {
        let newPrice = options[i].dataset.price;
        this.variantPrice.innerText = newPrice;
      }
    }
  }
  initAjaxProductForm () {
    new theme.AjaxProduct(this.form, '.add-to-cart');
  }
}

customElements.define('product-grid-item', ProductGridItem);
